<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
      <el-form-item label="留言标签:" prop="secondTag">
        <div>
          <el-select
            v-model="form.firstTag"
            @change="changeFirstTag"
            placeholder="请选择标签一级分类"
          >
            <el-option
              v-for="(item, index) in firstList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="form.secondTag"
            placeholder="请选择二级标签"
            style="margin-left: 10px"
          >
            <el-option
              v-for="(item, index) in secondList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="可见范围:" prop="visibleRange">
        <el-radio-group v-model="form.visibleRange">
          <el-radio
            v-for="(item, index) in rangeList"
            :key="index"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="图片:">
        <el-upload
          class="avatar-uploader"
          :headers="uploadHeaders"
          :action="upLoadUrl"
          :data="uploadData"
          accept=".png,.jpg,.ipeg"
          :on-success="handleSuccess"
          :on-error="handleUploadError"
          :on-remove="handleDelete"
          :before-upload="beforeAvatarUpload"
          list-type="picture-card"
        >
          <i class="el-icon-plus"> </i>
        </el-upload>
      </el-form-item>
      <el-form-item label="留言内容:" prop="content">
        <el-input
          type="textarea"
          :rows="6"
          placeholder="请输入内容"
          v-model="form.content"
          :maxlength="ruleObj.maxLength"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex; justify-content: center; padding: 20px">
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";
import { createLeaveMessage } from "@/api/moudles/user";

export default {
  props: {
    ruleObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,

      dialogTitle: "",
      dialogVisible: false,
      dialogWidth: "50%",

      form: {
        firstTag: "",
        secondTag: "",
        content: "",
      },
      imageList: [],
      rules: {
        secondTag: [
          {
            required: true,
            message: "二级标签不能为空",
            trigger: "change",
          },
        ],
        visibleRange: [
          {
            required: true,
            message: "可见范围不能为空",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "留言内容不能为空",
            trigger: "blur",
          },
        ],
      },
      firstList: [],
      secondList: [],
      rangeList: [
        {
          label: "公开",
          value: "1",
        },
        {
          label: "不公开",
          value: "0",
        },
      ],
      curRow: {},
    };
  },
  mounted() {
    console.log(this.$phoneSize());
    if (this.$phoneSize()) {
      this.dialogWidth = "95%";
    } else {
      this.dialogWidth = "50%";
    }
  },
  methods: {
    open(row, labelList) {
      if (row) {
        this.curRow = {
          ...row,
        };
        this.dialogTitle = "编辑留言";
      } else {
        this.dialogTitle = "新增留言";
      }
      this.firstList = [...labelList];
      this.imageList = [];
      this.dialogVisible = true;
    },
    async submit() {
      const valid = await this.$refs.formRef.validate();
      if (!valid) {
        return;
      }
      createLeaveMessage({
        data: {
          labelId: this.form.secondTag,
          question: this.form.content,
          visibility: this.form.visibleRange,
          attachments: this.imageList.map((i) => ({
            fileName: i.name,
            fileUrl: i.url,
          })),
        },
        success: () => {
          this.$message.success("提交成功");
          this.dialogVisible = false;
          this.form.content = "";
          this.$emit("refresh");
        },
        error: () => {
          this.$message.error("提交失败");
        },
      });
    },
    handleClose() {
      this.form.content = "";
      this.form = {};
      this.dialogVisible = false;
    },

    // 提交前验证
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      } else {
        this.imageList.push({
          name: file.name,
          url: "",
        });
      }

      return isLt2M;
    },
    // 覆盖原生提交
    handleSuccess(file) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageList[this.imageList.length - 1].url = file.data;
      this.imageList = [...this.imageList];
    },

    handleUploadError() {
      this.imageList.pop();
      this.$message.error("上传失败");
    },
    handleDelete() {
      this.imageList.pop();
    },
    changeFirstTag(value) {
      const obj = this.firstList.find((i) => i.id == value);
      if (obj && obj.children) {
        this.secondList = obj.children;
      }
      this.form.secondTag = "";
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
